export const getToast = ({ toast }) => toast;
